import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import {
  initial_pagination_values,
  useDRSContext,
} from "Pages/DRS/Context/DRSContext";
import { DRS_NEW_QUESTION } from "Pages/DRS/Constant/Constant";
// import { useDRSContext } from "Pages/DRS/Context/DRSContext";
import { drsEmitter } from "Pages/MyBatches/EmitterBus";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const DSRFilterHeader = React.lazy(
  () => import("Pages/DRS/DRSFilter/DSRFilterHeader")
);
const DSRDashboardFilter = React.lazy(
  () => import("Pages/DRS/DRSTabs/Dashboard/DRSDashboardFilter")
);
export const StyledDivHeader = styled<any>("div")`
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  border-radius: ${(props: any) =>
    props.isQuestionSessionStarted ? "12px" : ""};
  padding: ${(props: any) =>
    props.isQuestionSessionStarted ? "12px" : "12px 12px 0px 12px"};
`;
const DRSHeader = ({ tabIndex, setTabIndex }: any) => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, state } = location;
  const { regionName, stateName, branchName, regionId, stateId, branchId } =
    state || {};
  const { isQuestionSessionStarted, setPaginationDRSFilter, setIsSkipped } =
    useDRSContext();
  const getHeaderTitle = () => {
    if (pathname.includes("DRS/faculty/")) return state?.facultyName;
    if (pathname.includes("DRS/faculties")) return branchName;
    if (pathname.includes("DRS/branches")) return stateName;
    if (pathname.includes("DRS/states")) return regionName;
    return "Doubt Resolution System";
  };

  const handleBack = () => {
    setPaginationDRSFilter(initial_pagination_values);
    drsEmitter.emit(DRS_NEW_QUESTION, "clear");
    setIsSkipped(false);
    if (isQuestionSessionStarted) {
      const nextState = { ...state };
      delete nextState.mode;
      delete nextState.questionId;
      if (state?.facultyId) {
        navigate(`/admin/DRS/faculty/${state.facultyId}`, {
          state: nextState,
        });
      } else {
        navigate("/admin/DRS", {
          state: nextState,
        });
      }
    } else if (pathname.includes("DRS/faculty/")) {
      navigate(`/admin/DRS/faculties/${branchId}`, {
        state: { ...state },
      });
    } else if (pathname.includes("DRS/faculties")) {
      navigate(`/admin/DRS/branches/${stateId}`, {
        state: { regionId, regionName, stateName },
      });
    } else if (pathname.includes("DRS/branches")) {
      navigate(`/admin/DRS/states/${regionId}`, {
        state: { regionId, regionName },
      });
    } else if (pathname.includes("DRS/states")) {
      navigate("/admin/DRS");
    } else if (tabIndex === 1) {
      setTabIndex(0);
    } else {
      navigate("/admin/dashboard");
    }
  };

  return (
    <StyledDivHeader
      className="d-flex align-items-center justify-content-between"
      style={{
        background: "white",
      }}
      isQuestionSessionStarted={isQuestionSessionStarted}
    >
      <div className="d-flex align-items-center">
        <LeftArrow className={"cursorHoverCSS mr-1"} onClick={handleBack} />
        <Typography
          variant={["xxl", "xl"].includes(screen) ? "h4" : "h6"}
          color="black"
        >
          {getHeaderTitle()}
        </Typography>
      </div>
      {tabIndex == "0" ? (
        <React.Suspense fallback={"loading.."}>
          <DSRFilterHeader tabIndex={tabIndex}></DSRFilterHeader>
        </React.Suspense>
      ) : (
        <React.Suspense fallback={"loading.."}>
          <DSRDashboardFilter></DSRDashboardFilter>
        </React.Suspense>
      )}
    </StyledDivHeader>
  );
};

export default DRSHeader;
